import React from "react";

import tipKeys from "../assets/images/mover_teclas.svg";
import move from "../assets/images/i_mover.svg";
import tipMouse from "../assets/images/girar_raton.svg";
import rotate from "../assets/images/i_girar.svg";
import tipEsc from "../assets/images/esc.svg";
import escape from "../assets/images/i_salir.svg";
import tipPhoto from "../assets/images/F_foto.svg";
import photo from "../assets/images/i_foto.svg";

import InstructionTip from "./InstructionTip";

interface InstructionsProps {
  showDescriptions?: boolean;
}

const Instructions: React.FC<InstructionsProps> = ({showDescriptions}) => {
  return (
    <div className="flex">
      <InstructionTip
        imgKey={tipKeys}
        imgAction={move}
        imgHeight={12}
        lblAction="mover"
        txtAction={showDescriptions ? "Utiliza el teclado para moverte" : ""}
      />

      <InstructionTip
        className="ml-8 mr-4"
        imgKey={tipMouse}
        imgAction={rotate}
        imgHeight={12}
        lblAction="girar"
        txtAction={showDescriptions ? "Apunta e interactúa con el ratón" : ""}
      />

      <InstructionTip
        className="ml-4 mr-8"
        imgKey={tipEsc}
        imgAction={escape}
        imgHeight={12}
        lblAction="salir"
        txtAction={showDescriptions ? "Libera el puntero para interactuar" : ""}
      />

      <InstructionTip
        imgKey={tipPhoto}
        imgAction={photo}
        imgHeight={12}
        lblAction="foto"
        txtAction={showDescriptions ? "Captura la imagen en pantalla" : ""}
      />
    </div>
  );
};

export default Instructions;
